import React from 'react';

function Article() {
  return (
    <div className="video-article">
      <h3>Homebanking</h3>
      <p>Aprendé a realizar tus operaciones por los canales digitales</p>
      <div className="embed-container">
        <div className='embed-responsive embed-responsive-16by9 with-curves'>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/J-XSFPPzUtI?si=fAbOCKnXXeF2pyA-" title="Aprendé a realizar tus operaciones por los canales digitales" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
      </div>
    </div>
  );
}

export default Article;